import { FC } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { Icon } from '@frontend/icons';
import { getPriorityIcon } from '../../utils';
import { containerStyle } from './task-priority.styles';

interface TaskPriorityProps {
  priority: TaskCenterTypes.PriorityType;
}

export const TaskPriority: FC<TaskPriorityProps> = ({ priority }) => {
  const iconProps = getPriorityIcon(priority);

  return (
    <span css={containerStyle}>
      <Icon {...iconProps} />
    </span>
  );
};
